import axios from 'axios';
import { fromJS } from 'immutable';

const instance = axios.create({
  timeout: 3 * 1000,
  withCredentials: true,
});

instance.interceptors.request.use((requestConfig) => requestConfig, (error) => { throw error; });

instance.interceptors.response.use((responseConfig) => {
  const { status, data } = responseConfig;
  if (status === 200) {
    return fromJS(data);
  }
  return undefined;
}, (error) => { throw error; });

export default instance;
